const Colors = {
    "error": {
        50: "#fff1f0",
        100: "#ffccc7",
        200: "#ffa39e",
        300: "#ff7875",
        400: "#ff4d4f",
        500: "#f5222d",
        600: "#cf1322",
        700: "#a8071a",
        800: "#820014",
        900: "#5c0011"
    },
    "success": {
        50: "#f6ffed",
        100: "#d9f7be",
        200: "#b7eb8f",
        300: "#95de64",
        400: "#73d13d",
        500: "#52c41a",
        600: "#389e0d",
        700: "#237804",
        800: "#135200",
        900: "#092b00"
    },
    "warning": {
        50: "#fff7e5",
        100: "#ffeecc",
        200: "#ffdd99",
        300: "#ffcd66",
        400: "#ffbc33",
        500: "#ffab00",
        600: "#cc7a00",
        700: "#995200",
        800: "#663000",
        900: "#331400"
    },
    "primary": {
        50: "#e6f2ff",
        100: "#a3cdff",
        200: "#7ab2ff",
        300: "#5294ff",
        400: "#2974ff",
        500: "#0052ff",
        600: "#003dd9",
        700: "#002db3",
        800: "#001e8c",
        900: "#001366"
    },
    "aqua": {
        50: "#eafcff",
        100: "#d2f4f9",
        200: "#a5e9f2",
        300: "#77deec",
        400: "#4ad3e5",
        500: "#1dc8df",
        600: "#17a0b2",
        700: "#117886",
        800: "#0c5059",
        900: "#06282d"
    },
    "info": {
        50: "#eef6ff",
        100: "#d7eaff",
        200: "#afd5ff",
        300: "#87c0ff",
        400: "#5eacff",
        500: "#3697ff",
        600: "#2b79cc",
        700: "#215a99",
        800: "#163c66",
        900: "#0b1e33"
    },
    "green": {
        50: "#e8faf1",
        100: "#d3f6e4",
        200: "#a7ecca",
        300: "#7be3af",
        400: "#4fda95",
        500: "#24d07a",
        600: "#1ca762",
        700: "#157d49",
        800: "#0e5331",
        900: "#072a18"
    },
    "mint": {
        50: "#e9fffc",
        100: "#d5f7f2",
        200: "#abefe6",
        300: "#81e7d9",
        400: "#57decc",
        500: "#2dd6c0",
        600: "#24ab99",
        700: "#1b8173",
        800: "#12564d",
        900: "#092b26"
    },
    "purple": {
        50: "#f6f3ff",
        100: "#e5dffe",
        200: "#cbbefd",
        300: "#b19efc",
        400: "#977efb",
        500: "#7d5efa",
        600: "#644bc8",
        700: "#4b3896",
        800: "#322564",
        900: "#191332"
    },
    "rose": {
        50: "#fff0f4",
        100: "#ffdae3",
        200: "#ffb5c6",
        300: "#ff90aa",
        400: "#ff6b8d",
        500: "#ff4671",
        600: "#cc385a",
        700: "#992a44",
        800: "#661c2d",
        900: "#330e17"
    },
    "secondary": {
        50: "#f4f7fa",
        100: "#eff2f5",
        200: "#dee4eb",
        300: "#c3ccd6",
        400: "#a8b5c2",
        500: "#8593a3",
        600: "#6a7682",
        700: "#505862",
        800: "#353b41",
        900: "#1b1d21"
    },
    "overlay": {
        "black": "#1b1d2199",
        "white": "#ffffff66",
    },
}

export const {
    primary,
    error,
    success,
    warning,
    secondary,
    aqua,
    info,
    green,
    mint,
    purple,
    rose,
    overlay
} = Colors

export default Colors